import { render } from "./TodoCardEndResumo.vue?vue&type=template&id=1c46d398"
import script from "./TodoCardEndResumo.vue?vue&type=script&lang=js"
export * from "./TodoCardEndResumo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__